import { action } from 'typesafe-actions';
import { PreCasInterviewTypes } from './types';

export const createUpdatePCIFieldAction = (fieldName: string, value: any, refValue?: any) =>
  action(PreCasInterviewTypes.UPDATE_PCI_FIELD, { fieldName, value, refValue });

export const resetPCIQuestions = () => action(PreCasInterviewTypes.RESET_PCI_QUESTIONS);
